export default "__VITE_ASSET__D6Crm4V$__"